import type {ReactElement} from 'react';
import type {ChatMessagePartType} from '@Components/ai-chat-window/ai-chat-window.types';
import type {HumanInputButtonsComponentPart, ResumeWorkflowFn} from '@Components/ai-chat-window/components/human-input-buttons/human-input-buttons.types';
import type {PlanTableComponentPart} from '@Components/ai-chat-window/components/plan-table/plan-table.types';

export enum StreamComponentType {
  PLAN_TABLE = 'plan_table',
  HUMAN_INPUT_BUTTONS = 'human_input_buttons',
}

export interface StreamComponentContext {
  chatId: string;
  onResumeWorkflow?: ResumeWorkflowFn;
}

export interface StreamComponentRegistration<TComponentType extends StreamComponentType, TProps> {
  componentType: TComponentType;
  parseProps: (props: Record<string, unknown>) => TProps;
  render: (props: TProps, context: StreamComponentContext) => ReactElement;
}

export interface BaseComponentPart<TComponentType extends StreamComponentType, TProps> {
  type: ChatMessagePartType.COMPONENT;
  componentType: TComponentType;
  props: TProps;
}

export type ChatMessageComponentPart = PlanTableComponentPart | HumanInputButtonsComponentPart;
